import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import service from "../../../@services";
import { useEffect, useState } from "react";
export default ({detail,setDetail=()=>{}}) => {
  const [editorState,setEditorState] = useState(EditorState.createEmpty())
  useEffect(()=>{
    if(detail){
      const blockFromHTML = htmlToDraft(detail)
      const content = ContentState.createFromBlockArray(blockFromHTML.contentBlocks,blockFromHTML.entityMap)
      setEditorState(EditorState.createWithContent(content))
    }
  },[detail])
  const uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('file', file)
      service.common.uploadPictureFile(formData).then(res=>{
        resolve({
          data: {link:res}
        })
      }).catch((err) => { reject(err) })
    })
  }
  return (
    <Editor
      editorState={editorState}
      localization={ {locale: 'zh'}}
      toolbar={{
        image: {
          urlEnabled: false,
          uploadEnabled: true,
          alignmentEnabled: false,
          uploadCallback: uploadImageCallBack,
          previewImage: true,
          inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
          alt: { present: false, mandatory: false }
        }
      }}
      wrapperClassName="product-detail-wrapper"
      editorClassName="product-detail-editor"
      onEditorStateChange={setEditorState}
      onBlur={(event, editorState) => setDetail(draftToHtml(convertToRaw(editorState.getCurrentContent())))}
    />
  )
}